// Casca compartilhada das paginas institucionais publicas (sem login):
// Privacidade, Trocas e Devolucoes, Termos de Atendimento, A Loja.
// Header com voltar pro catalogo + cartao branco + rodape. Onda Google camada 1
// (destravar Merchant — sinais de confianca). Mesmo visual da Privacidade.
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { RodapeCatalogo } from './RodapeCatalogo';

export function Secao({ titulo, children }: { titulo: string; children: React.ReactNode }) {
  return (
    <section className="mt-5">
      <h2 className="text-base font-semibold" style={{ color: '#b45309' }}>
        {titulo}
      </h2>
      <div className="mt-1.5 text-sm leading-relaxed text-gray-700 space-y-2">{children}</div>
    </section>
  );
}

export function PaginaInstitucional({
  subtitulo,
  titulo,
  atualizadoEm,
  children,
}: {
  subtitulo: string; // linha pequena no header e <title>
  titulo: string; // titulo grande dentro do cartao
  atualizadoEm?: string;
  children: React.ReactNode;
}) {
  useEffect(() => {
    document.title = `${subtitulo} — FIODECOBRE`;
  }, [subtitulo]);

  return (
    <div
      className="catalogo-publico-root"
      style={{ minHeight: '100vh', backgroundColor: '#f7f7f7', color: '#111' }}
    >
      {/* Header com voltar */}
      <header style={{ backgroundColor: '#b45309', color: '#fff' }} className="sticky top-0 z-30 shadow">
        <div className="max-w-3xl mx-auto px-3 py-3 flex items-center gap-3">
          <Link
            to="/catalogo"
            className="inline-flex items-center justify-center rounded-full"
            style={{ width: 36, height: 36, backgroundColor: 'rgba(255,255,255,0.15)' }}
          >
            <ArrowLeft size={18} />
          </Link>
          <div className="flex-1 min-w-0">
            <h1 className="text-sm font-medium opacity-90 truncate">Fio de Cobre</h1>
            <p className="text-xs opacity-75 truncate">{subtitulo}</p>
          </div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-3 py-4">
        <div
          className="rounded-lg shadow-sm border border-gray-200 px-4 sm:px-6 py-5"
          style={{ backgroundColor: '#fff' }}
        >
          <h1 className="text-xl font-bold text-gray-900">{titulo}</h1>
          {atualizadoEm && (
            <p className="mt-1 text-xs text-gray-500">Ultima atualizacao: {atualizadoEm}</p>
          )}
          {children}
        </div>
      </main>

      <RodapeCatalogo />
    </div>
  );
}
